
    import './styles.scoped.css';
    export default {
  "grid": "awsui_grid_1mfbn_u2j2d_97",
  "grid-cell": "awsui_grid-cell_1mfbn_u2j2d_102",
  "day-header": "awsui_day-header_1mfbn_u2j2d_109",
  "week": "awsui_week_1mfbn_u2j2d_119",
  "day": "awsui_day_1mfbn_u2j2d_109",
  "day-inner": "awsui_day-inner_1mfbn_u2j2d_166",
  "in-first-row": "awsui_in-first-row_1mfbn_u2j2d_171",
  "in-previous-month": "awsui_in-previous-month_1mfbn_u2j2d_171",
  "last-day-of-month": "awsui_last-day-of-month_1mfbn_u2j2d_175",
  "in-next-month": "awsui_in-next-month_1mfbn_u2j2d_179",
  "in-first-column": "awsui_in-first-column_1mfbn_u2j2d_183",
  "in-current-month": "awsui_in-current-month_1mfbn_u2j2d_186",
  "enabled": "awsui_enabled_1mfbn_u2j2d_190",
  "in-range": "awsui_in-range_1mfbn_u2j2d_196",
  "end-date": "awsui_end-date_1mfbn_u2j2d_196",
  "start-date": "awsui_start-date_1mfbn_u2j2d_196",
  "no-range": "awsui_no-range_1mfbn_u2j2d_196",
  "selected": "awsui_selected_1mfbn_u2j2d_206",
  "today": "awsui_today_1mfbn_u2j2d_211",
  "range-start-date": "awsui_range-start-date_1mfbn_u2j2d_256",
  "in-range-border-bottom": "awsui_in-range-border-bottom_1mfbn_u2j2d_259",
  "range-end-date": "awsui_range-end-date_1mfbn_u2j2d_262",
  "in-range-border-top": "awsui_in-range-border-top_1mfbn_u2j2d_265",
  "in-range-border-right": "awsui_in-range-border-right_1mfbn_u2j2d_281",
  "in-range-border-left": "awsui_in-range-border-left_1mfbn_u2j2d_287"
};
  